jQuery(function ($) {
	$(function () {
		$('[data-toggle="tooltip"]').tooltip();
	});
});
